import React, { useEffect, useState } from "react";
import { Button, Card, CardBody } from "reactstrap";
import Breadcrumbs from "components/Breadcrumbs/breadcrumbs";
import TopHeader from "components/TopHeader/topHeader";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import Modal from "components/Modal/Modal";
import useApi from "../../../apiHooks/apiHooks";
import Swal from "sweetalert2";
import displayToast from "functions/displayToast";

export default function CompaniesEdit() {
    const [cookies, setCookie] = useCookies();
    const { id } = useParams();
    const { getCompanyDetails, deleteCompany, editCompany } = useApi();

    // Get Company Details
    const [companies, setCompanies] = useState(null);
    const getDetails = async () => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            const response = await getCompanyDetails(headers);
            setCompanies(response.data);
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
        }
    };

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        if (companies) {
            setInitialValues({
                companyName: companies.name,
                companyEmail: companies.email,
                password: "",
            });
        }
    }, [companies]);

    // Delete Company
    const removeCompany = async () => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            await deleteCompany(headers);
            displayToast("success", "Company deleted successfully");
            history.push("/admin/companies");
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
        }
    };

    // Formik
    const history = useHistory();
    const [initialValues, setInitialValues] = useState(null);
    const validationSchema = Yup.object({
        companyName: Yup.string().required("Company Name is required"),
        companyEmail: Yup.string().required("Company Email is required"),
    });
    const onSubmit = async (values) => {
        // console.log(`submit`, values);
        handleSubmit(values);
    };

    const handleSubmit = async (company) => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };

        let body = {
            name: company.companyName,
            email: company.companyEmail,
            password: company.password,
        };
        try {
            await editCompany(body, headers);

            displayToast("success", "Company edited successfully");
            history.push("/admin/companies");
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
            displayToast("error", "An Error has occurred");
        }
    };

    const styles = {
        input: { padding: "0.75rem", width: "70%" },
    };

    // Modal Delete
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            {initialValues && (
                <div className="m-5">
                    <TopHeader title={initialValues.companyName} />
                    <Breadcrumbs
                        pageLink="/admin/companies"
                        pageName="Companies"
                        currentPageName={initialValues.companyName}
                    />

                    <Card className="my-5">
                        <CardBody>
                            <h3
                                className="mb-5 mt-3"
                                style={{ fontWeight: "700", marginLeft: "2em" }}
                            >
                                Update the following fields to edit company
                                data:
                            </h3>

                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                            >
                                {(formik) => (
                                    <Form
                                        style={{
                                            marginTop: "2em",
                                            marginLeft: "2em",
                                        }}
                                    >
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Company Name:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    id="companyName"
                                                    name="companyName"
                                                    className="form-control"
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="companyName"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Email:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    name="companyEmail"
                                                    type="email"
                                                    id="companyEmail"
                                                    className="form-control"
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="companyEmail"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row my-5">
                                            <label
                                                className="col-sm-2 col-form-label"
                                                style={{ fontWeight: "700" }}
                                            >
                                                Password:
                                            </label>
                                            <div className="col-sm-10">
                                                <Field
                                                    name="password"
                                                    type="password"
                                                    id="password"
                                                    className="form-control"
                                                    style={styles.input}
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="red-text"
                                                    name="password"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                marginTop: "4em",
                                            }}
                                        >
                                            <Button
                                                color="danger"
                                                outline
                                                style={{ marginRight: "4em" }}
                                                onClick={() => {
                                                    setIsOpen(true);
                                                }}
                                            >
                                                Delete Company
                                            </Button>
                                            <Button
                                                color="default"
                                                type="submit"
                                                style={{
                                                    backgroundColor: "#01497C",
                                                    color: "white",
                                                }}
                                            >
                                                Save Changes
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </CardBody>
                    </Card>

                    <Modal
                        isOpen={isOpen}
                        title="Confirm Delete Company"
                        description="Do you wish to delete this company?"
                        handleClose={handleClose}
                        handleConfirm={removeCompany}
                    />
                </div>
            )}
        </>
    );
}
